// Hook do pobierania rodzajów providerów

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export interface IProviderKind {
  value: string;
  text: string;
}

interface IResponse {
  items: IProviderKind[];
}

const getProviderKinds = (): Promise<IResponse> =>
  axios.get('/dev-studio/process/provider-kinds');

export const useGetProviderKinds = (
  options?: UseQueryOptions<IResponse, IError>
) => useQuery<IResponse, IError>(['providerKinds'], () => getProviderKinds(), options);
